module.exports = __webpack_public_path__ + "static/img/icon3.3ea35792.png";